import { render, staticRenderFns } from "./TeacherRes.vue?vue&type=template&id=0299906d&scoped=true"
import script from "./TeacherRes.vue?vue&type=script&lang=js"
export * from "./TeacherRes.vue?vue&type=script&lang=js"
import style0 from "./TeacherRes.vue?vue&type=style&index=0&id=0299906d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299906d",
  null
  
)

export default component.exports